import { render, staticRenderFns } from "./step-slider.vue?vue&type=template&id=62cd6b9e&scoped=true&"
import script from "./step-slider.vue?vue&type=script&lang=ts&"
export * from "./step-slider.vue?vue&type=script&lang=ts&"
import style0 from "./step-slider.vue?vue&type=style&index=0&id=62cd6b9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cd6b9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62cd6b9e')) {
      api.createRecord('62cd6b9e', component.options)
    } else {
      api.reload('62cd6b9e', component.options)
    }
    module.hot.accept("./step-slider.vue?vue&type=template&id=62cd6b9e&scoped=true&", function () {
      api.rerender('62cd6b9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/wordpress/step-slider.vue"
export default component.exports